import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		isTimeOut: false, //连接超时
	},
	mutations: {
		changeIsTimeOut(state, flag) {
			state.isTimeOut = flag
		},
	},
	actions: {
  },
	modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js